import {
  Authentication_URL,
  ForgetPassword_URL,
  GetCompanies_URL,
  getPurchaseStatus_URL,
  POST_METHOD,
  Register_URL,
} from '../../Apis/api';

export const loginAuthentication = (loginBody) => {
  /* user authentication process */

  return fetch(Authentication_URL, {
    method: POST_METHOD,
    body: JSON.stringify(loginBody),
  }).then((response) => {

    return response.json();
  });
};

export const sendingPasswordOnEmail = (emailID) => {
  return fetch(ForgetPassword_URL, {
    method: POST_METHOD,
    body: JSON.stringify(emailID),
  }).then((response) => {
    return response.json();
  });
};

export const signupRequest = (signUpBody) => {
  return fetch(Register_URL, {
    method: POST_METHOD,
    body: JSON.stringify(signUpBody),
  }).then((response) => {
    return response.json();
  });
};

export const fetchCompanies = () => {
  return fetch(GetCompanies_URL, {
    method: POST_METHOD,
  }).then((response) => {
    return response.json();
  });
};

export const getPurchaseStatus_API = params => {
  return fetch(getPurchaseStatus_URL, {
    method: POST_METHOD,
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(params),
  }).then(response => response.json());
};

